import { Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Layout from './components/Layout';
import Aos from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';
import Datenschutz from './pages/Datenschutz';
import Impressum from './pages/impressum';

function App() {
  useEffect(() => {
    Aos.init({
      once: true,
    });
  }, []);
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
      </Route>
      <Route path="/datenschutz" element={<Layout />}>
        <Route index element={<Datenschutz />} />
      </Route>
      <Route path="/impressum" element={<Layout />}>
        <Route index element={<Impressum />} />
      </Route>
    </Routes>
  );
}

export default App;
